import React from 'react'

const Uploadproduct = () => {
  return (
    <div>Uploadproduct</div>
  )
}

export default Uploadproduct